import jsPDF from "jspdf";
import autoTable, { UserOptions } from "jspdf-autotable";
import { ExportColumn, ExportRow } from "../../types/ExportTypes";
import { getNestedValue } from "../getNestedValue";

export function exportPDF(
  columns: ExportColumn[],
  data: ExportRow[],
  filename: string = "export.pdf"
): void {
  const doc = new jsPDF({
    orientation: "landscape",
    unit: "pt",
    format: "a4",
  });

  const tableColumns = columns.map((col) => col.label);

  const tableRows = data.map((row) =>
    columns.map((col) => {
      const value = getNestedValue(row, col.key);
      if (col.key === "ativo") {
        return value ? "Ativo" : "Inativo";
      }
      return value;
    })
  );

  const options: UserOptions = {
    head: [tableColumns],
    body: tableRows,
    theme: "grid",

    styles: {
      fontSize: 9,
      lineColor: [180, 180, 180],
      lineWidth: 0.5,
    },
    headStyles: {
      fillColor: [52, 73, 94],
      textColor: [255, 255, 255],
      fontStyle: "bold",
    },
    alternateRowStyles: {
      fillColor: [245, 245, 245],
    },
  };

  autoTable(doc, options);
  doc.save(filename);
}
